import { useEffect, useState } from 'react';

const usePreviewMode = () => {
  const [isPreview, setIsPreview] = useState(false);

  useEffect(() => {
    setIsPreview(window.self !== window.top);
  }, []);

  return isPreview;
};

export default usePreviewMode;
